/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataReceiveAddressVo } from './PageDataReceiveAddressVo';
import {
    PageDataReceiveAddressVoFromJSON,
    PageDataReceiveAddressVoFromJSONTyped,
    PageDataReceiveAddressVoToJSON,
    PageDataReceiveAddressVoToJSONTyped,
} from './PageDataReceiveAddressVo';

/**
 * 
 * @export
 * @interface ResponsePageDataReceiveAddressVo
 */
export interface ResponsePageDataReceiveAddressVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataReceiveAddressVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataReceiveAddressVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataReceiveAddressVo}
     * @memberof ResponsePageDataReceiveAddressVo
     */
    data?: PageDataReceiveAddressVo;
}

/**
 * Check if a given object implements the ResponsePageDataReceiveAddressVo interface.
 */
export function instanceOfResponsePageDataReceiveAddressVo(value: object): value is ResponsePageDataReceiveAddressVo {
    return true;
}

export function ResponsePageDataReceiveAddressVoFromJSON(json: any): ResponsePageDataReceiveAddressVo {
    return ResponsePageDataReceiveAddressVoFromJSONTyped(json, false);
}

export function ResponsePageDataReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataReceiveAddressVoFromJSON(json['data']),
    };
}

export function ResponsePageDataReceiveAddressVoToJSON(json: any): ResponsePageDataReceiveAddressVo {
    return ResponsePageDataReceiveAddressVoToJSONTyped(json, false);
}

export function ResponsePageDataReceiveAddressVoToJSONTyped(value?: ResponsePageDataReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataReceiveAddressVoToJSON(value['data']),
    };
}

